export default __webpack_public_path__ + "static/media/icon_executive.ec02fae8.svg";